import * as tslib_1 from "tslib";
import { jsonMember, jsonObject } from "typedjson";
import { DxGridToolbarAction } from "./dx-grid-toolbar-action";
/** Опции кнопки панели иснтрументов списка. */
let DxGridToolbarButton = class DxGridToolbarButton {
    constructor(fields) {
        this._ord = 1;
        this._disabled = true;
        if (fields) {
            Object.assign(this, fields);
        }
    }
    get action() {
        return this._action;
    }
    set action(value) {
        this._action = value;
    }
    get title() {
        return this._title;
    }
    set title(value) {
        this._title = value;
    }
    get icon() {
        return this._icon;
    }
    set icon(value) {
        this._icon = value;
    }
    get ord() {
        return this._ord;
    }
    set ord(value) {
        this._ord = value;
    }
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = value;
    }
};
tslib_1.__decorate([
    jsonMember({ name: "title", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxGridToolbarButton.prototype, "_title", void 0);
tslib_1.__decorate([
    jsonMember({ name: "icon", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxGridToolbarButton.prototype, "_icon", void 0);
tslib_1.__decorate([
    jsonMember({ name: "ord", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], DxGridToolbarButton.prototype, "_ord", void 0);
tslib_1.__decorate([
    jsonMember({ name: "disabled", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxGridToolbarButton.prototype, "_disabled", void 0);
tslib_1.__decorate([
    jsonMember({ name: "action", constructor: DxGridToolbarAction, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", DxGridToolbarAction)
], DxGridToolbarButton.prototype, "_action", void 0);
DxGridToolbarButton = tslib_1.__decorate([
    jsonObject,
    tslib_1.__metadata("design:paramtypes", [Object])
], DxGridToolbarButton);
export { DxGridToolbarButton };
